import React from "react";
import PropTypes from "prop-types";
import { browserHistory } from "react-router";
import { connect } from "react-redux";
import { SubscriptionSettings } from "components/settings/subscription-settings";
import {
  fetchPlansAction,
  setPlanTypeDisplayAction,
  updatePlanAction,
  setCancelSubscriptionVisibilityAction,
  showUpgradeDowngradeModalAction,
  hideUpgradeDowngradeModalAction
} from "actions/account-settings-actions";
import { Loading } from "components/common/loading";

class SubscriptionSettingsPage extends React.Component {
  componentWillMount() {
    this.props.init(this.props.accountId);
  }

  render() {
    if (this.props.isLoading) {
      return <Loading />;
    }
    if (this.props.vip) {
      return browserHistory.push("/");
    }
    return (
      <SubscriptionSettings { ...this.props } />
    );
  }
}

SubscriptionSettingsPage.propTypes = {
  accountId: PropTypes.string.isRequired,
  init: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  vip: PropTypes.bool.isRequired
};

const mapStateToProps = (state) => ({
  accountId: state.app.selectedAccount.id,
  cancelDate: state.accountSettings.cancelDate,
  isCancelSubscriptionVisible: state.accountSettings.isCancelSubscriptionVisible,
  isChangePlanLoading: state.accountSettings.isChangePlanLoading,
  isLoading: state.accountSettings.isPlansLoading,
  isUpgradeDowngradeVisible: state.accountSettings.isUpgradeDowngradeVisible,
  pendingPlan: state.accountSettings.pendingPlan,
  plan: state.accountSettings.plan,
  plans: state.accountSettings.plans,
  planDetails: state.accountSettings.planDetails,
  planDisplay: state.accountSettings.planDisplay,
  vip: state.accountSettings.vip
});

const mapDispatchToProps = (dispatch) => ({
  init: (accountId) => dispatch(fetchPlansAction(accountId)),
  onHideCancelSubscription: () => dispatch(setCancelSubscriptionVisibilityAction(false)),
  onHideUpgradeDowngrade: () => dispatch(hideUpgradeDowngradeModalAction()),
  onShowCancelSubscription: () => dispatch(setCancelSubscriptionVisibilityAction(true)),
  onShowUpgradeDowngrade: (plan) => dispatch(showUpgradeDowngradeModalAction(plan)),
  onSetPlanDisplay: (type) => dispatch(setPlanTypeDisplayAction(type)),
  onUpdatePlan: (accountId, plan) => dispatch(updatePlanAction(accountId, plan))
});

export const SubscriptionSettingsContainer = connect(mapStateToProps, mapDispatchToProps)(SubscriptionSettingsPage);



// WEBPACK FOOTER //
// ./src/js/containers/settings/subscription-settings-container.jsx